import * as React from "react";
import { Form, Input, Row, Col } from "antd";
import { Image } from "@models/image";
import ImagePicker from "@components/custom/imagePicker";
import { FlagTag, Tag } from "@models/tag";
import { Checkbox } from "antd";
import TextEditor, { TextEditorRef } from "@components/custom/TextEditor";
import { FormattedMessage } from "react-intl";
import withFormWrapper from "@hocs/withFormWrapper";

interface PropsFromState {
  loading: boolean;
  errors?: string;
  form: any;
  tag?: Tag;
}


type TagFormStateShape = {
  title: string;
  slug: string;
  body: string;
  cover_image_file: Image | null;
  thumbnail_image_file: Image | null;
  flag: string;
};

const FlagOptions = [
  {
    label: <FormattedMessage id="app.hidden" defaultMessage={`Hidden`} />,
    value: FlagTag.HIDDEN
  }
  // { label: 'Has Page', value: FlagTag.HAS_PAGE },
];

class TagForm extends React.Component<PropsFromState, TagFormStateShape> {
  constructor(props) {
    super(props);
    const { tag } = props;
    this.state = {
      ...this.getStateFromProps(tag)
    };
  }

  private textEditorRef = React.createRef<TextEditorRef>();

  getStateFromProps = (tag: Tag | null): object => {
    //TODO check just once and set default values instead of inline if for each property!
    const obj = tag || {};
    return {
      title: obj.title || "",
      slug: obj.slug || "",
      body: obj.body || "",
      cover_image_file: obj.cover_image_file || null, //is not passed by in edit mode
      thumbnail_image_file: obj.thumbnail_image_file || null, //is not passed by in edit mode
      flag: obj.flag || FlagTag.NONE,
      id: obj.id
    };
  };

  /**
   * called from FormModal HOC
   * returns all the values should be passed in payload
   */
  getValues = () => {
    let returnValues = null;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        returnValues = {
          ...values,
          cover_image_file_id: this.state.cover_image_file
            ? this.state.cover_image_file.id
            : null,
          thumbnail_image_file_id: this.state.thumbnail_image_file
            ? this.state.thumbnail_image_file.id
            : null,
          body: this.textEditorRef.current
            ? this.textEditorRef.current.value
            : "",
          flag: this.state.flag || FlagTag.NONE
        };
      }
    });

    return {
      payload: returnValues,
      id: this.props.tag ? this.props.tag.id : null
    };
  };

  setCoverImage = (image: Image) => {
    this.setState({
      cover_image_file: image
    });
  };

  setThumbnailImage = (image: Image) => {
    this.setState({
      thumbnail_image_file: image
    });
  };

  onChangeFlags = checkedValues => {
    this.setState({
      flag: checkedValues.join("|")
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form className={"tag-form"}>
        <Row gutter={24}>
          <Col span={8}>
            <ImagePicker
              onSelectImage={this.setThumbnailImage}
              selectedImage={this.state.thumbnail_image_file}
            >
              <div
                className={`image-wrapper`}
                style={{
                  backgroundImage: `url(${
                    this.state.thumbnail_image_file
                      ? this.state.thumbnail_image_file.path
                      : ""
                  })`
                }}
              >
                <FormattedMessage
                  id="app.thumbnail_image"
                  defaultMessage={`Thumbnail Image`}
                />
              </div>
            </ImagePicker>
          </Col>
          <Col span={16} className={"cover-wrapper tag-cover-wrapper"}>
            <ImagePicker
              onSelectImage={this.setCoverImage}
              selectedImage={this.state.cover_image_file}
            >
              <div
                className={`cover-image`}
                style={{
                  backgroundImage: `url(${
                    this.state.cover_image_file
                      ? this.state.cover_image_file.path
                      : ""
                  })`
                }}
              >
                <FormattedMessage
                  id="app.cover_image"
                  defaultMessage={`Cover Image`}
                />
              </div>
            </ImagePicker>
          </Col>
   
          <Col span={8}>
            <Form.Item
              label={
                <FormattedMessage id="app.title" defaultMessage={`Title`} />
              }
            >
              {getFieldDecorator("title", {
                initialValue: this.state.title,
                rules: [
                  {
                    whitespace: true,
                    required: true,
                    message: (
                      <FormattedMessage
                        id="app.title_is_required"
                        defaultMessage={`Title is required!`}
                      />
                    )
                  }
                ]
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label={<FormattedMessage id="app.slug" defaultMessage={`Slug`} />}
            >
              {getFieldDecorator("slug", {
                initialValue: this.state.slug,
                rules: [
                  {
                    whitespace: true,
                    required: true,
                    message: (
                      <FormattedMessage
                        id="app.slug_is_required"
                        defaultMessage={`Slug is required!`}
                      />
                    )
                  }
                ]
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={8} className={`right-align`} style={{lineHeight:"50px"}}>
            <Checkbox.Group
              options={FlagOptions}
              defaultValue={this.state.flag.split("|")}
              onChange={this.onChangeFlags}
            />
          </Col>
          <Col span={24}>
            <Form.Item
              label={<FormattedMessage id="app.body" defaultMessage={`Body`} />}
            >
              {getFieldDecorator("body")(
                <TextEditor ref={this.textEditorRef} text={this.state.body} />
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default withFormWrapper(Form.create({ name: "tag-form" })(TagForm));
